import {
  AUTH_INIT_LOGIN, AUTH_LOGIN_FAILURE, AUTH_LOGIN_SUCCESS, AUTH_LOGOUT,
} from '../actions/types/authActionTypes';
import Auth from '../../models/Auth';

export default (state = new Auth(), action) => {
  switch (action.type) {
  case AUTH_INIT_LOGIN:
    return new Auth(state)
      .setLoggingIn(true)
      .setError('')
      .setUsername(action.payload.username);
  case AUTH_LOGIN_FAILURE:
    return new Auth(state)
      .setLoggingIn(false)
      .setLoggedIn(false)
      .setToken('')
      .setError(action.payload.error);
  case AUTH_LOGIN_SUCCESS:
    return new Auth(state)
      .setLoggingIn(false)
      .setLoggedIn(true)
      .setToken(action.payload.token)
      .setError('');
  case AUTH_LOGOUT:
    return new Auth();
  default:
    return state;
  }
};
